/**
 * Status van de orderbevestiging (de mail met PDF en Excel naar de klant).
 *
 * De API zet bij elke poging een Unix-timestamp (seconden) op de order:
 * `orderConfirmationSentAt` als de mail verstuurd is, `orderConfirmationFailedAt`
 * plus `orderConfirmationError` als hij mislukte. Een mislukte poging laat een
 * eerdere `orderConfirmationSentAt` staan, dus de laatste van de twee telt.
 *
 * Orders op rekening krijgen daarvóór `orderConfirmationRequestedAt`: de
 * bevestigingspagina van de webshop mag de mail maar één keer aanvragen. Blijft
 * een uitkomst daarna uit, dan is de API halverwege gestopt en is de mail
 * waarschijnlijk niet verstuurd.
 */
export const ORDER_CONFIRMATION_STATUS = {
  SENT: "sent",
  FAILED: "failed",
  PENDING: "pending",
  // Geen poging vastgelegd: orders van vóór deze registratie, of orders waarvan de
  // betaling nooit rond kwam (dan wordt er ook geen bevestiging verstuurd).
  UNKNOWN: "unknown",
};

// Versturen duurt seconden; zelfs als elke productfoto tegen de timeout loopt blijft het
// ruim onder dit kwartier.
export const ORDER_CONFIRMATION_NO_RESULT_AFTER_SECONDS = 15 * 60;

export const getOrderConfirmationStatus = (order, now = Math.floor(Date.now() / 1000)) => {
  const requestedAt = order?.orderConfirmationRequestedAt || null;
  const sentAt = order?.orderConfirmationSentAt || null;
  const failedAt = order?.orderConfirmationFailedAt || null;
  if (failedAt && (!sentAt || failedAt > sentAt)) {
    return {
      status: ORDER_CONFIRMATION_STATUS.FAILED,
      at: failedAt,
      error: order.orderConfirmationError || null,
      previouslySentAt: sentAt,
    };
  }
  if (sentAt) return { status: ORDER_CONFIRMATION_STATUS.SENT, at: sentAt };
  if (requestedAt) {
    if (now - requestedAt < ORDER_CONFIRMATION_NO_RESULT_AFTER_SECONDS) {
      return { status: ORDER_CONFIRMATION_STATUS.PENDING, at: requestedAt };
    }
    return { status: ORDER_CONFIRMATION_STATUS.FAILED, at: requestedAt, error: null, previouslySentAt: null, noResult: true };
  }
  return { status: ORDER_CONFIRMATION_STATUS.UNKNOWN };
};
